import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
/* eslint-disable @typescript-eslint/unified-signatures */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Ref } from 'vue-property-decorator';
import { cloneDeep, debounce, forEach, get, isEqual, values } from "lodash-es";
import mergeArray from '@tencent/data-schema-core/lib/utils/mergeArray';
import MaterialBox from "./comps/MaterialBox/index";
import CPropPanel from "./comps/PropPanel/index";
import UcdAside from "./comps/Aside";
import UcdAsidePane from "./comps/AsidePane";
import UcdEditZone from "./comps/EditZone";
import UcdToolbar from './designer/UcdToolbar/index';
import SettleComponent from "./comps/SettleComponent";
import AlternateComponents from "./comps/AlternateComponents/index";
import DataPathSelectPopover from "./comps/DataPathSelectPopover";
import CreateTriggerDialog from './comps/ToolBarWidget/CreateTriggerDialog';
import CreateReportDialog from './comps/ToolBarWidget/CreateReportDialog';
import GlobalComponentPluginArgsDialog from './comps/ToolBarWidget/GLobalPluguinArgsDialog/GlobalPluginArgsDialog';
import UpsertStateVariableDialog from './comps/UpsertStateVariableDialog';
import SkeletonStyleDialog from "../lib/comps/ToolBarWidget/SkeletonStyleDialog";
import DomTree from "./comps/DomTree/index";
import UcWindow from "./UcWindow";
import clearContainerSvg from "../lib/assets/actionIcons/outBox.svg";
import { compPathToSourcePath, computeNewCompPath, getCompPathParentInfo, getLayoutFromPagelet, getLayoutIdLUT, getLayoutIdLUTFromPagelet, getLayoutSlot, isLayoutHasChild, sourcePathToCompPath, splitCompPath, walkLayout } from './utils/layout';
import { INJECT_UICORE_DESIGNER } from './utils/consts';
import { publicCompMixin } from './publicComp';
import { createBus } from './ucBus';
import { isInsideRect } from './utils/styling';
import { vueDeepAssign, createVueDataProxy, vueDeepSet, CalmComputedGetter, vueBailDepCollector } from './utils/vue';
import { arrayify, findAndRemove } from './utils/array';
import { getVariableName } from './utils';
import EditZoneState from './designer/EditZoneState';
import { getVNodeFactoryState } from './renderer/utils';
import { setConstValue, Trie } from './utils/collections';
import { collectDeps } from './designer/collectDeps';
import { resolveGenerator } from './utils/async/resolveGenerator';
import { message } from 'ant-design-vue';
import { splitPath } from '@tencent/data-schema-core/lib/utils/path';
import { RightTopCorner } from "../lib/designer/RightTopCorner";
import { builtinComponents, builtinDesignerComponents, builtinFlowAtoms } from './builtin';
import ExprInputCompletionProvider from './comps/ExprInput/ExprInputCompletionProvider';
import { vueLinkLocalStorage } from "../lib/utils/vue";
import ZoomFitState from "../lib/designer/utils/ZoomFitState";
import MockState from "../lib/designer/utils/MockState";
import { vueLinkStorageWithDefaultObjectValue } from "../lib/utils/vue/vueLinkStorageWithDefaultValue";
import { StylePanelState } from './designer/StylePanelState';
import UcWindowManager from "../lib/comps/UpsertStateVariable/UcWindowManager";
import { filterCompActions } from './designer/utils/compActions';
import { ContextMenu } from './comps/ContextMenu';
import { getCompContextMenuSections } from './designer/utils/contextMenu';
import { getBaseLayout } from "../lib/designer/utils/layout";
import { domBfs } from "../lib/utils/browser/domBfs";
import { subscribeVueDataProxyChange } from './utils/vue/vueDataProxy';
const DesignerBase = publicCompMixin.extend({
  props: {
    editZoneStyle: {
      type: String,
      default: ''
    },
    editZoneClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  components: {
    UcdAside,
    UcdAsidePane,
    UcdToolbar,
    MaterialBox,
    CPropPanel,
    UcWindow,
    UcdEditZone,
    DomTree,
    SettleComponent,
    AlternateComponents
  },
  provide() {
    return {
      [INJECT_UICORE_DESIGNER]: this
    };
  }
});
/** 使用修饰器挂载的一些生命周期回调方法 */
// eslint-disable-next-line @typescript-eslint/naming-convention
const $_extraHooks = {};
/** 使用修饰器去挂载一些生命周期 */
const lifeCycle = cycle => (obj, fnName) => {
  if (!$_extraHooks[cycle]) {
    $_extraHooks[cycle] = [fnName];
    return;
  }
  $_extraHooks[cycle].push(fnName);
};
// #endregion --------------------------------
let UcDesigner = class UcDesigner extends DesignerBase {
  constructor() {
    super(...arguments);
    /** 最外层的 CRenderer */
    this.rootRenderer = null;
    /** 当前用户在做什么 */
    this.currentOperation = '';
    /** （currentOperation === 'binding' 时有值）当前要bind的 */
    this.currentBindingDataStub = null;
    // ------------------------------------------------------
    // #region canvas缩放
    /** 对editZone-canvas进行的缩放等级 100=100%缩放 */
    this.zoom = 100;
    /** 控制缩放时页面的宽度 */
    this.pageWidth = 'auto';
    // 编辑区域真实宽高
    this.editSize = {
      width: 0,
      height: 0
    };
    // #endregion
    // ------------------------------------------------------
    /** 控制编辑器内的一些样式开关 */
    /** 控制CompSkeleton中error边框 和蓝色条件边框的显隐 */
    this.skeletonStyle = {};
    this.displayComponentDemo = true;
    this.compPathHistoryMaxNum = 10;
    this.contextMenuContent = null;
    // #endregion
    // ------------------------------------------------------
    // ------------------------------------------------------
    // #region render 函数以及渲染相关的东西
    this.rightSideExpanded = true;
    /**
     * EditZone 会使用一个随机值追加在key末尾，这样就可以强行重建预览区的 CRenderer。
     * 通过强制重建，解决 lessCode 不生效的问题
     */
    this.canvasRandom = 0;
    // #endregion
    // ------------------------------------------------------
    // ------------------------------------------------------
    // #region 编辑 Scope 相关 之 基本能力
    this.scopeStack = [];
    // #endregion
    // ------------------------------------------------------
    // #region 编辑当前选择的组件（comp, aka. layout）相关，这个是 ”当前在编辑的东西“ 的一个特殊情况
    this.internalCompPath = '';
    /**
     * 当前在编辑的组件 prop
     *
     * 注意，一旦输入框丢失焦点，这个就会变回空字符串。建议使用 `this.$watch(() => this.uc.designer?.activeCompProp, (propId) => {  })` 的方式加自定义逻辑
     */
    this.activeCompProp = '';
    /**
     * 当前拖拽是从哪里来的。
     *
     * 不要直接修改，请通过 setDragSource 修改！
     */
    this.dragSource = null;
    /** 鼠标悬停在的组件。也会在 EditZone 被高亮显示 */
    this.hoveringCompPath = '';
    this.internalHighlightCompPaths = {};
    // #endregion
    // ------------------------------------------------------
    // #region 依赖收集、当前绑定情况
    /**
     * 当前 renderer 对变量的各种依赖
     *
     * 注意！这里拿到的不一定是最新的！请参考 `depsIsUpdating` 这个变量
     *
     * 如果需要拿最新的，可以通过 `async getNewestDeps()` 获取，但是这个可能会卡住，做好心里准备
     */
    this.deps = null;
    this.depsIsUpdating = true;
    this.startCollectDeps = debounce(() => {
      this.startCollectDepsImmediately();
    }, 1000);
    // #endregion
    // ------------------------------------------------------
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  $_runExtraHooks(cycle) {
    forEach($_extraHooks === null || $_extraHooks === void 0 ? void 0 : $_extraHooks[cycle], fnName => this[fnName]());
  }
  addToZoom(newZoom) {
    // 通过菜单操作可能出现 67% 75%缩放 下面将缩放对齐到10
    const fixOperation = newZoom > 0 ? Math.floor : Math.ceil;
    let fixedZoom = fixOperation(this.zoom / 10) * 10 + newZoom;
    // 将 缩放 限制到 [40,200]
    fixedZoom = Math.max(40, fixedZoom);
    // 当缩放超出200%时 不允许用户手动放大 只允许缩小
    if (fixedZoom > 200 && newZoom > 0) return;
    this.$emit('zoom-changed-user');
    this.zoom = fixedZoom;
  }
  /** 直接修改zoom 并且产生zoom修改事件 */
  changeZoomByUser(newZoom) {
    if (newZoom !== this.zoom) this.$emit('zoom-changed-user');
    this.zoom = newZoom;
  }
  getZoomPercentage() {
    return this.zoom / 100;
  }
  /** 在xy-clinet进行编辑时 可以切换编辑和预览 使用了v-if导致切换预览时designer被销毁
   * 通过localstorage同步上次的缩放结果
   */
  saveZoomBetweenRendererAndDesigner() {
    // 默认缩放取100%
    this.zoom = vueLinkLocalStorage(this, 'UcDesigner', 'zoom') || 100;
  }
  createZoomFitState() {
    const cachePageWidth = localStorage.getItem('uicore:pageWidth');
    // type guard
    if (cachePageWidth === 'auto' || cachePageWidth === 'mobile') {
      this.pageWidth = cachePageWidth;
    } else {
      this.pageWidth = parseInt(cachePageWidth || '', 10) || 'auto';
    }
    this.zoomFitState = new ZoomFitState({
      parent: this
    });
  }
  destroyZoomFitState() {
    this.zoomFitState.$destroy();
  }
  /** 用户手动操作变更pageWidth时发出事件通知 */
  setPageWidth(newPageWidth, isMobile = false) {
    const pageWidth = newPageWidth === 'mobile' ? 414 : newPageWidth;
    this.$emit('pageWidth-changed-user', pageWidth, isMobile);
    this.pageWidth = pageWidth;
  }
  /** 画布宽度发生变化时向外部暴露宽度变化 */
  pageWidthChange(width) {
    this.$emit('pageWidthChange', width);
  }
  get designerConfig() {
    // 历史原因，保留别名
    return this.skeletonStyle;
  }
  retrieveCompPathHistoryMaxNum() {
    this.compPathHistoryMaxNum = parseInt(localStorage.getItem('uicore:compPathHistory') || '', 10) || 10;
  }
  saveSkeletonStyle() {
    // 首先要保证用户没读写过的值的key是不存在于localstorage里的
    // 然后要保证默认值合并到getter里 不能让这些值的使用方写出===false这种东西来
    vueLinkStorageWithDefaultObjectValue(this, 'UcDesigner', 'skeletonStyle', localStorage, this.uc.config.designerConfig);
  }
  handleContextMenuClose() {
    this.contextMenuContent = null;
    if (this.contextMenuCustomOnClose) this.contextMenuCustomOnClose();
    this.contextMenuCustomOnClose = null;
  }
  openContextMenu(ev, content, onClose) {
    this.contextMenuContent = content;
    this.contextMenuRef.open(ev, {
      parent: this.$el
    });
    this.contextMenuCustomOnClose = onClose;
  }
  openContextMenuForActiveComp(ev) {
    this.openContextMenu(ev, getCompContextMenuSections(this, {
      eventTarget: ev.target
    }), () => {
      this.editZoneState.editZone.focus();
    });
  }
  createMockState() {
    this.mockState = new MockState({
      parent: this
    });
    this.$once('beforeDestroy', () => this.mockState.$destroy());
  }
  // #endregion
  // ------------------------------------------------------
  // ------------------------------------------------------
  // #region 属性面板
  /** 显示属性面板 */
  showPropPanel() {
    this.$refs.propPanelPane.isExpanded = true;
  }
  openSettleComponentWindow(options) {
    const settleComponent = this.$refs.settleComponent;
    settleComponent.openWindow(options);
  }
  openCompAlternatesWindow(options) {
    const compAlternates = this.$refs.alternateComponents;
    compAlternates.openWindow(options);
  }
  /**
   * 打开“选择一个字段”的浮层，会返回 Promise(内容是用户选择的 dataPath)。
   *
   * 需要注意的是，如果用户取消了操作，会返回 null 或者空字符串
   */
  openDataPathSelector(options) {
    return this.$refs.dataPathSelectPopover.open(options);
  }
  openCreateTriggerDialog(req) {
    return this.$refs.createTriggerDialog.show(req);
  }
  openCreateReportDialog(req) {
    return this.$refs.createReportDialog.show(req);
  }
  openGlobalComponentPluginArgsDialog(req) {
    return this.$refs.GlobalComponentPluginArgsDialog.show(req);
  }
  /** 更改CompSkeleton显隐状态 */
  openSkeletonStyleDialog(req) {
    return this.$refs.skeletonStyleDialog.show(req);
  }
  // #endregion
  // ------------------------------------------------------
  // ------------------------------------------------------
  // #region Designer 生命周期
  beforeCreate() {
    this.uc = createBus(this, {
      isDesignMode: true,
      builtinAssets: {
        components: builtinComponents,
        designerComponents: builtinDesignerComponents,
        flowAtoms: builtinFlowAtoms
      }
    });
    this.uc.designer = this;
    this.uc.hooks.rootBeforeCreate.call(this);
  }
  created() {
    this.editZoneState = new EditZoneState({
      parent: this
    });
    this.stylePanelState = new StylePanelState({
      parent: this
    });
    this.$_runExtraHooks('created');
  }
  mounted() {
    this.$_runExtraHooks('mounted');
  }
  beforeDestroy() {
    this.editZoneState.$destroy();
    this.stylePanelState.$destroy();
    this.$_runExtraHooks('beforeDestroy');
  }
  getDataStubOfRenderer() {
    var _this$renderer;
    return (_this$renderer = this.renderer) === null || _this$renderer === void 0 ? void 0 : _this$renderer.ucDataStub;
  }
  render() {
    var _this$pagelet;
    const h = arguments[0];
    const layout = (_this$pagelet = this.pagelet) === null || _this$pagelet === void 0 ? void 0 : _this$pagelet.layout;
    return h("div", {
      "class": "uc-designer"
    }, [h("ucd-toolbar", {
      "class": "uc-designer-toolbar",
      "ref": "toolbar"
    }), h("ucd-edit-zone", {
      "class": `uc-designer-editZone ${this.editZoneClass}`,
      "style": this.editZoneStyle,
      "ref": "editZone"
    }), h("ucd-aside", {
      "class": "uc-designer-leftSidebar",
      "key": "leftSide",
      "attrs": {
        "position": "left",
        "width": "375px",
        "id": "ucd_leftSide",
        "saveExpanded": this.skeletonStyle.saveAsideExpandState
      }
    }, [h("ucd-aside-pane", {
      "key": "materialBox",
      "style": "flex: 1"
    }, [h("slot", {
      "attrs": {
        "name": "materialBox"
      }
    }, [h(MaterialBox, {
      "ref": "materialBox"
    })])]), !!layout && this.uc.config.designerUiConfig.domTreeView && h("ucd-aside-pane", {
      "class": "ucd-aside-pane-domTree",
      "key": "domTreeView",
      "attrs": {
        "title": "布局结构",
        "height": "350px",
        "defaultCollapsed": true,
        "destroyChildrenWhenCollapsed": true
      }
    }, [h("dom-tree", {
      "attrs": {
        "layout": layout
      }
    })])]), this.rightSideExpanded && h(RightTopCorner), h("ucd-aside", {
      "ref": "asideRight",
      "class": "uc-designer-rightSidebar",
      "key": "rightSide",
      "attrs": {
        "position": "right",
        "width": "400px",
        "data-ucd-report-mod": "右侧工具栏",
        "saveExpanded": this.skeletonStyle.saveAsideExpandState
      },
      "on": {
        "expand": () => this.rightSideExpanded = true,
        "collapse": () => this.rightSideExpanded = false
      }
    }, [h("ucd-aside-pane", {
      "key": "propPanel",
      "ref": "propPanelPane",
      "style": "flex: 1",
      "class": "uc-designer-propPanelWrapper",
      "attrs": {
        "disableCollapsing": true
      }
    }, [this.renderer && h(CPropPanel, {
      "ref": "designerRightPanel"
    })])]), h("settle-component", {
      "ref": "settleComponent"
    }), h("alternate-components", {
      "ref": "alternateComponents"
    }), h(ExprInputCompletionProvider, {
      "attrs": {
        "dataStub": this.getDataStubOfRenderer
      }
    }, [h("div", [h(DataPathSelectPopover, {
      "ref": "dataPathSelectPopover"
    }), h(UcWindowManager, {
      "attrs": {
        "component": UpsertStateVariableDialog,
        "getUniqueId": opt => !opt.isEditingExisting ? `create${opt.id}` : opt.id
      },
      "ref": "upsertStateVariableDialogManager"
    }), h(CreateTriggerDialog, {
      "ref": "createTriggerDialog"
    }), h(CreateReportDialog, {
      "ref": "createReportDialog"
    }), h(GlobalComponentPluginArgsDialog, {
      "ref": "GlobalComponentPluginArgsDialog"
    }), h(SkeletonStyleDialog, {
      "ref": "skeletonStyleDialog"
    })])]), h(ContextMenu, {
      "ref": "contextMenuRef",
      "attrs": {
        "content": this.contextMenuContent
      },
      "on": {
        "close": this.handleContextMenuClose
      }
    }), h("portal-target", {
      "attrs": {
        "name": "default"
      }
    }), h("portal-target", {
      "attrs": {
        "name": "editZone"
      },
      "class": "uc-designer-portalTarget-editZone"
    })]);
  }
  /**
   * 销毁重建 Canvas，在需要重新初始化 CRenderer 实例时使用
   */
  recreateCanvas() {
    this.canvasRandom = (this.canvasRandom + 1) % 1e9;
  }
  /**
   * 当前的编辑 Scope
   */
  get scope() {
    var _this$scopeStack;
    return (_this$scopeStack = this.scopeStack[this.scopeStack.length - 1]) !== null && _this$scopeStack !== void 0 ? _this$scopeStack : this.rootScope;
  }
  get rootScope() {
    return {
      renderer: this.rootRenderer,
      compPath: '',
      getPagelet: () => this.rootPagelet,
      setPagelet: val => {
        this.rootPagelet = val;
      },
      prevCompPath: ''
    };
  }
  /**
   * 有时候因为页面变化，CRenderer 实例可能会无效化，此时需要做清理，请调用这个方法
   */
  cleanInvalidScope() {
    let changed = false;
    while (this.scopeStack.length > 0) {
      var _scope$renderer;
      const scope = this.scopeStack[this.scopeStack.length - 1];
      if (!((_scope$renderer = scope.renderer) !== null && _scope$renderer !== void 0 && _scope$renderer.ucMounted) || !scope.getPagelet()) {
        changed = true;
        this.exitScope();
      } else {
        break;
      }
    }
    if (changed) this.uc.notifyPageletsChange(0);
  }
  /**
   * 切换当前编辑Scope
   *
   * 这个功能比较高级，建议使用其他 enter 开头的方法，例如 enterScopeSlot
   */
  enterDesignerScope(opt) {
    var _opt$prevCompPath;
    const currentScope = this.scope;
    this.scopeStack.push({
      renderer: opt.renderer || currentScope.renderer,
      compPath: opt.compPath || '',
      getPagelet() {
        return opt.getPagelet();
      },
      setPagelet(v) {
        opt.setPagelet(v);
      },
      parent: currentScope,
      prevCompPath: (_opt$prevCompPath = opt.prevCompPath) !== null && _opt$prevCompPath !== void 0 ? _opt$prevCompPath : this.compPath
    });
  }
  /**
   * 开始编辑某个 scopedSlot 的内容
   */
  async enterScopedSlot(opt) {
    var _currentComp$scopedSl, _opt$prevCompPath2;
    const {
      compPath,
      slotId,
      renderer
    } = opt;
    // 有时候组件升级了，在 meta.slots 引入了新的插槽，并带来了默认值。但是父页面片JSON里实际是没有对应的插槽布局数据的
    // 这种时候， enterScopedSlot 需要帮他创建一个数据先
    const currentComp = this.getCompAtPath(compPath);
    if (!currentComp) return; // bad compPath!!!
    if (!((_currentComp$scopedSl = currentComp.scopedSlots) !== null && _currentComp$scopedSl !== void 0 && _currentComp$scopedSl[slotId])) {
      const factoryState = getVNodeFactoryState(this.renderer, compPath); // 这个时候还没进入 scope 所以用旧的 renderer 来找
      let defaultSubPagelet;
      // case 1: ComponentMeta 里声明的默认值
      {
        var _factoryState$factory;
        defaultSubPagelet = factoryState === null || factoryState === void 0 || (_factoryState$factory = factoryState.factory) === null || _factoryState$factory === void 0 || (_factoryState$factory = _factoryState$factory.scopedSlotMetas) === null || _factoryState$factory === void 0 || (_factoryState$factory = _factoryState$factory.find(x => x.id === slotId)) === null || _factoryState$factory === void 0 ? void 0 : _factoryState$factory.default;
      }
      // case 2: 动态作用域插槽（要检查这个 CRenderer 是否是作用域插槽生成的）
      if (!defaultSubPagelet) {
        const list = factoryState === null || factoryState === void 0 ? void 0 : factoryState.getScopedSlotInstances(slotId);
        if (list !== null && list !== void 0 && list.includes(renderer)) defaultSubPagelet = cloneDeep(renderer.ucPagelet);
      }
      // case 3: final check
      if (!defaultSubPagelet) {
        throw new Error(`Component ${compPath} has no default for scopedSlot ${slotId}`);
      }
      await this.modifyComp(compPath, comp => {
        if (!comp.scopedSlots) this.$set(comp, 'scopedSlots', {});
        this.$set(comp.scopedSlots, slotId, cloneDeep(defaultSubPagelet));
      });
    }
    // 暂存当前的 pagelet 源
    const getUpperPagelet = this.scope.getPagelet;
    const getComp = () => getLayoutFromPagelet(getUpperPagelet(), compPath);
    this.enterDesignerScope({
      renderer,
      getPagelet: () => {
        var _getComp;
        return (_getComp = getComp()) === null || _getComp === void 0 || (_getComp = _getComp.scopedSlots) === null || _getComp === void 0 ? void 0 : _getComp[slotId];
      },
      setPagelet: val => {
        const comp = getComp();
        // console.log(`[setPagelet!!] ${compPath}/${slotId}`, val);
        this.$set(comp.scopedSlots, slotId, val);
      },
      prevCompPath: (_opt$prevCompPath2 = opt.prevCompPath) !== null && _opt$prevCompPath2 !== void 0 ? _opt$prevCompPath2 : this.compPath // 回到上级的时候，选中老的组件
    });
    this.clearUpsertStateVariableDialog();
    await this.$nextTick(() => {
      // 防止compPath污染 直接选中作用域插槽的根组件
      this.compPath = '';
      // 进入作用域插槽后如果鼠标不移动会导致hoveringCompPath更新不及时 这里人工设置一下
      this.hoveringCompPath = '';
    });
  }
  /**
   * 退出当前的编辑 Scope
   */
  exitScope() {
    var _this$scopeStack$pop;
    const compPath = ((_this$scopeStack$pop = this.scopeStack.pop()) === null || _this$scopeStack$pop === void 0 ? void 0 : _this$scopeStack$pop.prevCompPath) || '';
    this.compPath = compPath;
    this.clearUpsertStateVariableDialog();
  }
  $_watchPageletId() {
    // 页面片重新初始化
    this.$watch('pageletId', () => {
      this.scopeStack = [];
      this.compPath = '';
    }, {
      immediate: true
    });
    // 子页面片变化时可能需要清理
    this.$watch(() => {
      var _this$scope$renderer;
      return (_this$scope$renderer = this.scope.renderer) === null || _this$scope$renderer === void 0 ? void 0 : _this$scope$renderer.ucMounted;
    }, () => {
      this.cleanInvalidScope();
    });
  }
  // #endregion
  // ------------------------------------------------------
  // ------------------------------------------------------
  // #region 编辑 Scope 相关 之 页面片、渲染器、页面变量
  /**
   * 当前 scope 的页面片实例，等同 `scope.renderer`
   */
  get renderer() {
    return this.scope.renderer;
  }
  /**
   * 当前 scope 的页面片，同 `this.scope.pagelet`
   */
  get pagelet() {
    return this.scope.getPagelet();
  }
  set pagelet(v) {
    this.scope.setPagelet(v);
    this.uc.notifyPageletsChange(0);
  }
  /**
   * 显示一个弹窗，为页面添加或者更新页面变量（stateSchema）
   *
   * 这个方法不是那么常用，请考虑使用这两个替代方法：
   *
   * - openCreateStateVariableDialog
   * - openEditStateVariableDialog
   */
  async openUpsertStateVariableDialog(opt) {
    const manager = this.$refs.upsertStateVariableDialogManager;
    const response = manager.show(opt);
    return response;
  }
  async openCreateStateVariableDialog(opt) {
    return this.openUpsertStateVariableDialog(opt);
  }
  async openEditStateVariableDialog(opt) {
    var _this$pagelet2;
    const schema = (_this$pagelet2 = this.pagelet) === null || _this$pagelet2 === void 0 || (_this$pagelet2 = _this$pagelet2.stateSchema) === null || _this$pagelet2 === void 0 ? void 0 : _this$pagelet2.fields.find(x => x.id === opt.id);
    if (!schema) return null;
    return this.openUpsertStateVariableDialog({
      isEditingExisting: schema,
      id: opt.id,
      place: opt.place
    });
  }
  /** 关闭所有变量编辑框 */
  clearUpsertStateVariableDialog() {
    // clear和模板参数无关
    this.$refs.upsertStateVariableDialogManager.clear();
  }
  /**
   * 修改当前页面片的 stateSchema 并提交修改
   *
   * - 如果传了 dataSchema 就执行 upsert
   * - 如果有 deleteId 就执行删除
   * - upsert 在删除之后执行
   *
   * 另外，如果要打开变量编辑对话框，请使用：
   *
   * - openCreateStateVariableDialog
   * - openEditStateVariableDialog
   */
  async updateStateVariable(dataSchema, deleteId) {
    if (!this.pagelet) return;
    const rawStateSchema = this.pagelet.stateSchema || {
      type: 'object',
      fields: []
    };
    let fields = [...(rawStateSchema.fields || [])];
    if (deleteId) findAndRemove(fields, x => x.id === deleteId);
    if (dataSchema) fields = mergeArray(fields, [dataSchema], 'id');
    this.pagelet = {
      ...this.pagelet,
      stateSchema: {
        ...rawStateSchema,
        fields
      }
    };
  }
  // #endregion
  // ------------------------------------------------------
  // ------------------------------------------------------
  // #region 编辑 Scope 相关 之 编辑任一组件
  /**
   * 生成一个能用的，新的组件ID。比如，如果有无效字符会剔除；有重名会加尾缀……
   *
   * @param name 随便传一个非空字符串就行，例如 layout.type、原来的 id
   * @param allowingIds 默认会做去重，但是有的 ID 其实是允许使用的。可以传入那些允许使用的ID
   */
  getAvailableComponentId(name, allowingIds) {
    const {
      pagelet
    } = this;
    const oldLUT = pagelet ? getLayoutIdLUTFromPagelet(pagelet) : undefined;
    if (oldLUT && allowingIds) {
      arrayify(allowingIds).forEach(id => {
        delete oldLUT[id];
      });
    }
    return getVariableName(name, oldLUT);
  }
  /**
   * 给定一个 clientX, clientY，找到所在位置的 compPath。如果没匹配到会返回空字符串
   *
   * @param filter 额外的筛选函数，可以不传
   */
  compFromPoint(clientX, clientY, filter) {
    var _this$renderer2;
    let answer = '';
    const editZoneCanvas = this.$refs.editZone.$refs.rendererCanvas;
    const rendererUUID = (_this$renderer2 = this.renderer) === null || _this$renderer2 === void 0 ? void 0 : _this$renderer2.ucRendererUUID;
    const isTarget = (el, path) => {
      var _this$uc$components$t;
      const iRendererUUID = el.getAttribute('data-uc-renderer-uuid') || '';
      if (!path) return false;
      if (!iRendererUUID || iRendererUUID !== rendererUUID) return false;
      const type = el.getAttribute('data-uc-type') || '';
      const componentMeta = (_this$uc$components$t = this.uc.components[type]) === null || _this$uc$components$t === void 0 ? void 0 : _this$uc$components$t.meta;
      if (componentMeta !== null && componentMeta !== void 0 && componentMeta.isUnselectable) return false;
      if (filter && !filter({
        path,
        type,
        componentMeta
      })) return false;
      return true;
    };
    // 如果定义了pointer-event:none 则有些元素并不会被 elementsFromPoint 找到
    document.elementsFromPoint(clientX, clientY).find(el => {
      if (!editZoneCanvas.contains(el)) return false;
      const path = el.getAttribute('data-uc-path') || '';
      if (!isTarget(el, path)) return false;
      answer = path;
      return true;
    });
    // 尝试高级一点的寻找方式
    if (answer === '') {
      // 为了性能优化 先不考虑绝对定位的事情 如果鼠标不在节点里 可以提前结束子树的bfs
      const jumpBfs = el => !isInsideRect(clientX, clientY, el.getBoundingClientRect());
      for (const el of domBfs(editZoneCanvas, jumpBfs)) {
        const path = el.getAttribute('data-uc-path') || '';
        if (!isTarget(el, path)) continue;
        return path;
      }
    }
    return answer;
  }
  /**
   * 用来执行 action 的 execute，执行完成后会同步layout（如果需要）
   */
  async executeAction(fn, e = null) {
    if (!fn) return;
    await fn(e);
    this.uc.notifyPageletsChange(0);
  }
  /**
   * 获取对应位置上的 UICore.Layout 对象
   */
  getCompAtPath(path) {
    const sourcePath = compPathToSourcePath(path);
    return get(this.pagelet, sourcePath);
  }
  /**
   * 获取对应位置上的 UICore.Layout 对象
   *
   * 只是 getCompAtPath 的别名
   */
  getLayoutAtPath(path) {
    return this.getCompAtPath(path);
  }
  async modifyPagelet(modifier) {
    if (!this.pagelet) return;
    const proxyComp = createVueDataProxy(this.pagelet);
    await modifier(proxyComp);
    this.uc.notifyPageletsChange();
  }
  /**
   * 替换某个组件为其他的东西
   */
  async replaceCompWith(compPath, ...newItems) {
    if (!compPath) {
      if (this.pagelet && newItems.length === 1) {
        this.pagelet = {
          ...this.pagelet,
          layout: newItems[0]
        };
      }
      return;
    }
    await this.spliceComp(compPath, compPath, newItems);
  }
  /**
   * 更新组件的某个 Prop。
   * 这里会做清理，如果有默认值的话就不写入到 props 里。
   */
  async updateCompProp(compPath, name, value) {
    await this.modifyComp(compPath, c => {
      var _this$uc$components$c;
      const compPropsDefaults = ((_this$uc$components$c = this.uc.components[c.type]) === null || _this$uc$components$c === void 0 ? void 0 : _this$uc$components$c.defaultProps) || {};
      const isDefault = isEqual(compPropsDefaults[name], value);
      if (isDefault) {
        if (c.props && name in c.props) Vue.delete(c.props, name);
      } else {
        if (!c.props) Vue.set(c, 'props', {
          [name]: value
        });else Vue.set(c.props, name, value);
      }
    });
  }
  /**
   * 删除某个组件
   */
  async deleteComp(path) {
    if (!path.length) return; // 页面片根组件不能删除
    await this.spliceComp(path);
    if (path === this.compPath && !this.activeComp) {
      var _getCompPathParentInf;
      this.compPath = ((_getCompPathParentInf = getCompPathParentInfo(path)) === null || _getCompPathParentInf === void 0 ? void 0 : _getCompPathParentInf.parentCompPath) || '';
    }
  }
  /**
   * 修改某个组件 Layout 数据，可自定义修改过程
   *
   * @param path  组件路径，例如 "/default/0/default/2"
   * @param change 可以是一个（异步/同步的）回调函数,在这里随意改造 comp 对象；也可是一个 `Partial<UICore.Layout>`，会使用 **浅层** Object.assign 修改组件
   */
  async modifyComp(path, change) {
    const comp = getLayoutFromPagelet(this.pagelet, path);
    if (!comp) return;
    const proxyComp = createVueDataProxy(comp);
    if (typeof change === 'function') {
      let changed = false;
      const stopObserving = subscribeVueDataProxyChange(() => changed = true);
      const rootLayoutProxy = createVueDataProxy(this.pagelet.layout);
      try {
        await change(proxyComp, rootLayoutProxy);
      } catch (error) {
        console.error('[UICore] modifyComp error', path, error);
      }
      stopObserving();
      if (changed) {
        this.uc.notifyPageletsChange();
      }
    } else {
      if (!isLayoutHasChild(comp)) {
        // 如果是单层组件 做一次diff
        const noChange = Object.entries(change).every(([key, value]) => isEqual(comp[key], value));
        if (noChange) return;
      }
      Object.assign(proxyComp, change);
      this.uc.notifyPageletsChange();
    }
  }
  /**
   * 将某个组件从一个位置移动到另外一个位置
   *
   * @param toDeleteCompPaths  要删除的组件，可以是单个或者多个 CompPath
   * @param insertPoint   参考位置（相对于删除前），用于执行插入逻辑
   * @param items   要插入的新组件们
   * @returns 发生删除行为后，新的插入参考位置
   */
  async spliceComp(toDeleteCompPaths, insertPoint, items) {
    const {
      pagelet
    } = this;
    if (!pagelet) return;
    let actuallyChanged = false;
    let newInsertPoint = insertPoint;
    let pendingDeletePoints = Array.isArray(toDeleteCompPaths) ? toDeleteCompPaths.slice(0) : [toDeleteCompPaths];
    // 为了能够做自动的 ID 补全，需要准备个这玩意
    const existingComponents = getLayoutIdLUTFromPagelet(pagelet);
    // 先执行删除
    while (pendingDeletePoints.length) {
      const deletePoint = pendingDeletePoints.pop();
      if (!deletePoint) continue;
      const slotPath = compPathToSourcePath(deletePoint);
      const index = +slotPath.pop();
      if (Number.isNaN(index)) continue;
      const slot = get(pagelet, slotPath);
      if (!Array.isArray(slot) || slot.length <= index) continue;
      // 插槽存在且元素存在，实际删除逻辑
      const removed = slot.splice(index, 1);
      if (removed.length) {
        actuallyChanged = true;
        // 需要清除已有ID的组件列表
        removed.forEach(removedLayout => {
          Object.keys(getLayoutIdLUT(removedLayout)).forEach(key => {
            delete existingComponents[key];
          });
        });
      }
      // 如果插槽为空了，且不是 default 插槽，就可以删除他了
      const slotIsEmptied = slot.length === 0;
      if (slotIsEmptied) {
        this.$delete(
        // 坑爹，lodash 的 get 传入空 path 会返回 undefined
        slotPath.length === 1 ? pagelet : get(pagelet, slotPath.slice(0, -1)),
        // 要删除的 key，比如 children / triggers ...
        slotPath[slotPath.length - 1]);
      }
      // 由于发生了删除行为，原来的 points 会对应发生修改
      const actionsThatAffects = [{
        action: 'delete',
        compPath: deletePoint
      }];
      pendingDeletePoints = pendingDeletePoints.map(x => x && computeNewCompPath(x, actionsThatAffects));
      if (newInsertPoint && newInsertPoint !== deletePoint) {
        newInsertPoint = computeNewCompPath(newInsertPoint, actionsThatAffects);
      }
    }
    // 再执行插入
    if (items && newInsertPoint) {
      const array = arrayify(items);
      const slotPath = compPathToSourcePath(newInsertPoint);
      const index = +slotPath.pop();
      // 自动补全 ID
      array.forEach(subLayout => {
        walkLayout(subLayout, ({
          layout
        }) => {
          var _layout$componentId;
          const rawId = ((_layout$componentId = layout.componentId) === null || _layout$componentId === void 0 ? void 0 : _layout$componentId.replace(/\d+$/, '')) || layout.type;
          const newId = getVariableName(rawId, existingComponents);
          existingComponents[newId] = true;
          layout.componentId = newId;
        });
      });
      const slot = get(pagelet, slotPath);
      if (!slot) {
        vueDeepSet(pagelet, slotPath, [...array]);
      } else {
        slot.splice(index, 0, ...array);
      }
      actuallyChanged = true;
    }
    if (actuallyChanged) {
      this.uc.notifyPageletsChange(0);
    }
    return newInsertPoint;
  }
  /**
   * 为组件添加或者取消绑定
   *
   * @param dataPath 绑定到的目标path。如果为空，则当作取消绑定
   */
  async setBinding(compPath, bindingId, dataPath) {
    let compMeta;
    let bindingMeta;
    let dataStub;
    await this.modifyComp(compPath, comp => {
      var _compMeta;
      compMeta = this.uc.components[comp.type];
      bindingMeta = (_compMeta = compMeta) === null || _compMeta === void 0 || (_compMeta = _compMeta.meta.bindings) === null || _compMeta === void 0 ? void 0 : _compMeta.find(x => x.id === bindingId);
      if (!bindingMeta) return;
      vueDeepAssign(comp, {
        bindings: {
          [bindingId]: dataPath || undefined
        }
      });
      dataStub = dataPath ? this.renderer.getStubAtPath(dataPath) : null;
      if (dataPath && bindingMeta.onBind) {
        bindingMeta.onBind({
          dataPath,
          dataSchema: dataStub.schema,
          dataStub: dataStub,
          renderer: this.renderer,
          uc: this.uc,
          options: {}
        }, comp);
      }
    });
    if (bindingMeta && compMeta) {
      var _dataStub;
      await this.uc.hooks.setBinding.promise({
        uc: this.uc,
        designer: this,
        bindingId,
        bindingMeta,
        isMainBinding: compMeta.mainBindingId === bindingId,
        compMeta,
        compPath,
        dataPath,
        dataSchema: (_dataStub = dataStub) === null || _dataStub === void 0 ? void 0 : _dataStub.schema,
        dataStub
      });
    }
  }
  /**
   * 为组件取消绑定
   */
  async removeBinding(compPath, bindingId) {
    return this.setBinding(compPath, bindingId);
  }
  /**
   * 有的组件因为插槽的原因，是不可删除的，但是它的父组件可以删除
   *
   * 使用这个方法可以找到能删除的父组件
   *
   * 如果返回空字符串 表示完全没有可删除的东西
   */
  getNearestDeletableCompPath(compPath) {
    // 根节点肯定是不能删除的
    if (!compPath) return '';
    const pathParts = splitCompPath(compPath).reverse();
    for (let i = 0; i < pathParts.length; i++) {
      var _iFactoryState$getNor;
      const pathInfo = pathParts[i];
      // 对于 frozen 的插槽，里面的元素也不可删除
      const iFactoryState = getVNodeFactoryState(this.renderer, pathInfo.parentCompPath);
      if (!iFactoryState) break;
      const slot = (_iFactoryState$getNor = iFactoryState.getNormalSlots()) === null || _iFactoryState$getNor === void 0 ? void 0 : _iFactoryState$getNor.find(x => x.id === pathInfo.slotId);
      if (slot && !slot.allowDeleteChildren) continue; // 这个组件不能删除
      return pathInfo.compPath; // 这个组件可删除
    }
    return ''; // nothing works
  }
  getComponentDesignerContext(path) {
    const layout = this.getCompAtPath(path);
    if (!layout) return null;
    const renderer = this.scope.renderer;
    const factoryState = getVNodeFactoryState(renderer, path);
    const factory = factoryState === null || factoryState === void 0 ? void 0 : factoryState.factory;
    const meta = factory === null || factory === void 0 ? void 0 : factory.compMeta;
    const instance = renderer.getRefByPath(path);
    const ans = {
      path,
      layout,
      meta,
      designer: this,
      renderer,
      uc: this.uc,
      instance,
      factory,
      factoryState,
      modifyComp: this.modifyComp.bind(this, path),
      updateCompProp: this.updateCompProp.bind(this, path),
      deleteComp: this.deleteComp.bind(this, path),
      replaceCompWith: this.replaceCompWith.bind(this, path)
    };
    return Object.seal(ans);
  }
  /**
   * 给定一个place参数，获取组件指定位置（比如 ActionBar、PropPanel）的 actions
   *
   * @param place - 可选，如果传了，则只返回对应位置的actions。
   *                不建议使用，最好是拿到全量结果，然后 `filterCompActions`
   */
  getCompActions(path, place) {
    var _factoryState$getDesi, _getCompPathParentInf2, _ans;
    const componentDesignerContext = this.getComponentDesignerContext(path);
    if (!componentDesignerContext) return [];
    const {
      layout,
      meta,
      instance,
      factoryState
    } = componentDesignerContext;
    let ans = [];
    const reqCtx = {
      ...componentDesignerContext
    };
    // 首先走 meta 里定义的 getActions
    try {
      var _meta$getActions;
      // 这里的 map 是处理历史问题，以前是可返回字符串的
      ans = (meta === null || meta === void 0 || (_meta$getActions = meta.getActions) === null || _meta$getActions === void 0 || (_meta$getActions = _meta$getActions.call(meta, reqCtx)) === null || _meta$getActions === void 0 ? void 0 : _meta$getActions.filter(Boolean).map(x => typeof x === 'string' ? {
        title: x
      } : x)) || [];
    } catch (error) {
      console.error(`Failed to getActions for ${layout.type}`, error);
    }
    // 添加一个绝对定位的东西
    if (path && factoryState !== null && factoryState !== void 0 && (_factoryState$getDesi = factoryState.getDesignerFlags()) !== null && _factoryState$getDesi !== void 0 && _factoryState$getDesi.allowFloating) {
      var _layout$style;
      ans.unshift({
        icon: 'fa fa-thumb-tack',
        title: '浮动',
        highlighted: (layout === null || layout === void 0 || (_layout$style = layout.style) === null || _layout$style === void 0 ? void 0 : _layout$style.position) === 'absolute',
        execute: async () => {
          await this.modifyComp(path, comp => {
            var _layout$style2, _el$offsetLeft, _el$offsetTop, _el$offsetWidth;
            const wasAbsolute = (layout === null || layout === void 0 || (_layout$style2 = layout.style) === null || _layout$style2 === void 0 ? void 0 : _layout$style2.position) === 'absolute';
            if (wasAbsolute) {
              // 删除原有的那些鬼东西
              vueDeepAssign(comp, {
                style: {
                  position: undefined,
                  zIndex: undefined,
                  left: undefined,
                  top: undefined,
                  width: undefined,
                  height: undefined
                }
              });
              return;
            }
            const el = instance === null || instance === void 0 ? void 0 : instance.$el;
            vueDeepAssign(comp, {
              style: {
                position: 'absolute',
                zIndex: 1,
                left: `${(_el$offsetLeft = el === null || el === void 0 ? void 0 : el.offsetLeft) !== null && _el$offsetLeft !== void 0 ? _el$offsetLeft : 0}px`,
                top: `${(_el$offsetTop = el === null || el === void 0 ? void 0 : el.offsetTop) !== null && _el$offsetTop !== void 0 ? _el$offsetTop : 0}px`,
                width: `${(_el$offsetWidth = el === null || el === void 0 ? void 0 : el.offsetWidth) !== null && _el$offsetWidth !== void 0 ? _el$offsetWidth : 0}px`
              }
            });
          });
        }
      });
    }
    if (path && !path.startsWith('/@')) {
      // 添加保存为模版的东西
      ans.unshift({
        icon: '',
        title: '保存模版',
        place: ['propPanel', 'contextMenu'],
        execute: async () => {
          if (!this.compPath || !this.activeComp) {
            message.error({
              content: '请先选中某个区块'
            });
            return;
          }
          this.$emit('template-create', {
            comp: this.activeCompInstance,
            designer: this
          });
        }
      });
    }
    const parentCompPath = (_getCompPathParentInf2 = getCompPathParentInfo(path)) === null || _getCompPathParentInf2 === void 0 ? void 0 : _getCompPathParentInf2.parentCompPath;
    const parentComp = parentCompPath && this.getCompAtPath(parentCompPath);
    if (parentComp && parentComp.type === 'w-paragraph') {
      var _layout$style3;
      const wasFlexGrow = (_layout$style3 = layout.style) === null || _layout$style3 === void 0 ? void 0 : _layout$style3.flexGrow;
      ans.unshift({
        icon: 'fa fa-arrows-h',
        title: '撑满行',
        highlighted: !!wasFlexGrow,
        execute: async () => {
          await this.modifyComp(path, comp => {
            if (wasFlexGrow) {
              vueDeepAssign(comp, {
                style: {
                  flexGrow: undefined,
                  flexBasis: undefined,
                  minWidth: undefined
                } // 与样式面板中flex同步，取消撑满行时，清空所有flex相关样式
              });
              return;
            }
            vueDeepAssign(comp, {
              style: {
                flexGrow: 1
              }
            });
          });
        }
      });
    }
    const hasChildren = Array.isArray(layout.children) && layout.children.length > 0;
    const hasSlot = layout.slots;
    const hasScopedSlots = layout.scopedSlots;
    if (hasChildren || hasSlot || hasScopedSlots) {
      ans.unshift({
        icon: clearContainerSvg,
        title: '清空容器',
        place: 'propPanel',
        execute: () => {
          this.modifyComp(path, comp => {
            if (hasChildren) {
              this.$set(comp, 'children', []);
            }
            if (hasSlot) {
              this.$delete(comp, 'slots');
            }
            if (hasScopedSlots) {
              this.$delete(comp, 'scopedSlots');
            }
          });
        }
      });
    }
    if (meta !== undefined && path !== '') {
      ans.unshift({
        icon: 'fa fa-random',
        title: '更换组件',
        execute: () => {
          const replaceAns = this.uc.hooks.getReplaceComponent.call([], reqCtx);
          if (!replaceAns.length) {
            message.warning('暂无可更换的组件');
            return;
          }
          this.openSettleComponentWindow({
            place: document.activeElement || instance.$el,
            compPath: path,
            title: '选择要更换的组件',
            dataPath: '',
            applyAlternateCallback: async ({
              item
            }) => {
              item.applyCallback(item);
            },
            // 定义了placeCompInside 或者属于布局容器的都纳入推荐列表
            getAlternates: () => this.uc.fitDataSort(replaceAns)
          });
        }
      });
    }
    // 然后是 uc hooks
    ans = this.uc.hooks.getActionsOfComponent.call(ans, reqCtx);
    // 最后是过滤
    ans = ((_ans = ans) === null || _ans === void 0 ? void 0 : _ans.filter(Boolean)) || [];
    if (place) ans = filterCompActions(ans, place);
    return ans;
  }
  // #endregion
  // ------------------------------------------------------
  // ------------------------------------------------------
  // #region 当前在编辑的东西
  /**
   * 当前正在编辑什么东西
   *
   * 这个是相对于当前 pagelet 的 path，例如 `["layout", "children", "2"]`
   */
  get sourcePath() {
    // 依赖作用域层级和compPath
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.compPath;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.scopeStack;
    return vueBailDepCollector(() => {
      let {
        renderer
      } = this;
      const sourcePath = [...compPathToSourcePath(this.compPath)];
      while (renderer) {
        if (renderer.ucScopedSlotOwner) {
          // 作用域插槽ID
          sourcePath.unshift(renderer.ucScopedSlotId);
          sourcePath.unshift('scopedSlots');
          // 持有作用域插槽的组件的compPath
          sourcePath.unshift(...compPathToSourcePath(renderer.ucScopedSlotOwner.compPath));
          // 插槽的父级renderer
          renderer = renderer.ucParentRenderer;
        } else {
          break;
        }
      }
      return sourcePath;
    });
  }
  set sourcePath(p) {
    this.setSourcePath(p);
  }
  // 因为进入作用域插槽涉及异步操作 只能用函数来设置
  async setSourcePath(p) {
    // 按照scopedSlots切分
    const operation = [];
    const splitSourcePath = path => {
      const index = path.findIndex(item => item === 'scopedSlots');
      const compPath = index === -1 ? sourcePathToCompPath(path) : sourcePathToCompPath(path.slice(0, index));
      operation.push({
        compPath: compPath || ''
      });
      if (index === -1) return;
      const slotsSourcePath = path.slice(index);
      // 推出scopedSlots
      slotsSourcePath.shift();
      // 插槽名字
      operation.push({
        scopedSlots: slotsSourcePath.shift()
      });
      splitSourcePath(slotsSourcePath);
    };
    splitSourcePath(p);
    // 退作用域
    // TODO: 其实不用退那么多的 退到前缀一样就行了
    while (this.scopeStack.length > 0) {
      this.exitScope();
    }
    for (const op of operation) {
      if (typeof op.compPath === 'string') {
        this.compPath = op.compPath;
      } else if (op.scopedSlots) {
        const comp = this.activeCompInstance;
        if (!comp) break;
        let renderer;
        const slotId = op.scopedSlots;
        if (comp.ucScopedSlotInstances) {
          // 使用UcScopedSlot实例化出来的作用域插槽
          const scopedSlotSet = comp.ucScopedSlotInstances[op.scopedSlots];
          if (!scopedSlotSet) break;
          const scopedSlot = Array.from(scopedSlotSet)[0];
          renderer = scopedSlot === null || scopedSlot === void 0 ? void 0 : scopedSlot.renderer;
        } else {
          var _comp$$vnode;
          // 预定义在mata里的原生作用域插槽
          const factoryState = (_comp$$vnode = comp.$vnode) === null || _comp$$vnode === void 0 || (_comp$$vnode = _comp$$vnode.data) === null || _comp$$vnode === void 0 ? void 0 : _comp$$vnode['uc:VNodeState'];
          if (!factoryState) break;
          renderer = factoryState.getScopedSlotInstances(slotId)[0];
        }
        if (!renderer) break;
        await this.enterScopedSlot({
          renderer,
          slotId,
          compPath: this.compPath
        });
      }
    }
  }
  $_initCompPath() {
    // 如果用户只是刷新了页面呢?回来的时候帮他选中
    const cacheKey = this.uc.config.userCacheKey + this.pageletId;
    const compPath = sessionStorage.getItem(cacheKey) || '';
    if (!compPath) return;
    this.internalCompPath = compPath;
  }
  $_initCompPathMounted() {
    const {
      compPath
    } = this;
    const comp = this.getCompAtPath(compPath);
    if (!comp) this.internalCompPath = '';
  }
  /**
   * 当前选中的组件的 CompPath
   */
  get compPath() {
    return this.internalCompPath;
  }
  set compPath(p) {
    this.internalCompPath = p;
    if (this.scopeStack.length === 0 && this._isMounted) {
      vueBailDepCollector(() => {
        const cacheKey = this.uc.config.userCacheKey + this.pageletId;
        cacheKey && sessionStorage.setItem(cacheKey, p);
      });
    }
  }
  /**
   * 当前选中的组件的 Vue 实例，直接访问即可。
   */
  get activeCompInstance() {
    var _this$scope$renderer2;
    return (_this$scope$renderer2 = this.scope.renderer) === null || _this$scope$renderer2 === void 0 ? void 0 : _this$scope$renderer2.getRefByPath(this.compPath);
  }
  get activeComp() {
    return this.getCompAtPath(this.compPath);
  }
  get activeCompType() {
    var _this$activeComp;
    return ((_this$activeComp = this.activeComp) === null || _this$activeComp === void 0 ? void 0 : _this$activeComp.type) || '';
  }
  get activeCompMeta() {
    return this.uc.components[this.activeCompType];
  }
  get activeCompDefaultProps() {
    var _this$activeCompMeta;
    return (_this$activeCompMeta = this.activeCompMeta) === null || _this$activeCompMeta === void 0 ? void 0 : _this$activeCompMeta.defaultProps;
  }
  get activeCompActions() {
    return this.getCompActions(this.compPath);
  }
  getActiveCompActions(place) {
    const actions = this.activeCompActions || [];
    if (place) return filterCompActions(actions, place);
    return actions;
  }
  /** 选中当前组件的父组件 */
  selectParent() {
    var _getCompPathParentInf3;
    this.compPath = ((_getCompPathParentInf3 = getCompPathParentInfo(this.compPath)) === null || _getCompPathParentInf3 === void 0 ? void 0 : _getCompPathParentInf3.parentCompPath) || '';
  }
  selectFirstChild() {
    var _this$activeComp2;
    if (!((_this$activeComp2 = this.activeComp) !== null && _this$activeComp2 !== void 0 && _this$activeComp2.children)) return;
    this.compPath += '/default/0';
  }
  selectAdjacentComp(offset) {
    if (!this.compPath) return;
    const {
      parentCompPath,
      index: oldIndex,
      slotId
    } = getCompPathParentInfo(this.compPath);
    const parent = this.getCompAtPath(parentCompPath);
    const slot = getLayoutSlot(parent, slotId, false);
    if (!slot) return;
    let index = oldIndex + offset;
    if (index >= slot.length) index = slot.length - 1;else if (index < 0) index = 0;
    this.compPath = `${parentCompPath}/${slotId}/${index}`;
  }
  /**
   * 删除当前组件
   *
   * 删除前请检查 ，并删除最合适可删除的组件
   */
  async deleteActiveComp() {
    const compPath = this.getNearestDeletableCompPath(this.compPath);
    if (!compPath) return;
    await this.deleteComp(compPath);
    this.compPath = compPath;
  }
  /**
   * 更新当前选中的组件的某个 Prop。
   *
   * 这个是 `updateCompProp(this.compPath, ...)` 的简写，如果需要可以去看看那个方法的说明
   */
  async updateActiveCompProp(name, value) {
    return this.updateCompProp(this.compPath, name, value);
  }
  /**
   * 修改当前选中的组件
   *
   * 这个是 `modifyComp(this.compPath, ...)` 的简写，如果需要可以去看看那个方法的说明
   */
  async modifyActiveComp(changes) {
    await this.modifyComp(this.compPath, changes);
  }
  $_watchCompPath() {
    // 选中的组件变化时，需要重置一下
    this.$watch('compPath', () => {
      this.internalHighlightCompPaths = {}; // FIXME: 有时候使用方忘记 setHighlight(..., false)，在这里重置合适么
      setTimeout(this.showPropPanel, 200);
    });
    // 如果选择了一个不可选中的组件，或者组件无效，就转为选中它的上级
    this.$watch(() => {
      var _this$activeCompMeta2;
      return !this.activeComp || ((_this$activeCompMeta2 = this.activeCompMeta) === null || _this$activeCompMeta2 === void 0 ? void 0 : _this$activeCompMeta2.isUnselectable);
    }, isUnselectable => {
      if (isUnselectable && this.compPath) {
        var _getCompPathParentInf4;
        this.compPath = ((_getCompPathParentInf4 = getCompPathParentInfo(this.compPath)) === null || _getCompPathParentInf4 === void 0 ? void 0 : _getCompPathParentInf4.parentCompPath) || '';
      }
    });
    // 如果当前编辑的 scope 消失了（比如，组件的插槽列表发生了变化）
    // 那就回到上一层
    this.$watch(() => !this.pagelet && this.scopeStack.length, shallGoParent => {
      if (shallGoParent) this.cleanInvalidScope();
    });
  }
  // #endregion
  // ------------------------------------------------------
  // ------------------------------------------------------
  // #region 拖拽相关
  /** 是否处于拖拽状态。这个由 currentOperation 管控 */
  get isDragging() {
    return this.currentOperation === 'dragging';
  }
  /** 开始拖拽时，需要设置这个 */
  async setDragSource(info) {
    if (!info) {
      this.currentOperation = '';
      this.dragSource = null;
      return;
    }
    const ans = {
      ...info
    };
    let {
      layout
    } = ans;
    if (typeof layout === 'object' && typeof layout.then === 'function') {
      layout = await layout;
    }
    if (Array.isArray(layout) && layout.length === 1) layout = layout[0]; // 有时会拿到 [Layout] 这种长度1的数组，解开它
    ans.layout = cloneDeep(layout);
    // 补充特殊字段：组件信息
    if (!Array.isArray(layout)) {
      setConstValue(ans, 'compMeta', this.uc.components[layout.type]);
    }
    // 补充特殊字段：数据源拖拽
    if (ans.dataPath) {
      var _this$renderer3;
      setConstValue(ans, 'dataStub', (_this$renderer3 = this.renderer) === null || _this$renderer3 === void 0 ? void 0 : _this$renderer3.getStubAtPath(ans.dataPath));
    }
    // 最后提交
    this.dragSource = ans;
    this.currentOperation = 'dragging';
  }
  /**
   * 结束拖拽时，要检查当前组件是否为 inline 组件。如果是 inline 组件，要确保他是在 w-paragraph 里面
   *
   * @param o.xPos 鼠标在槽的释放位置（0-1）
   */
  async processAfterDrop(o) {
    var _this$activeCompMeta3, _this$dragSource3, _this$dragSource3$onD;
    const {
      compPath
    } = this;
    // 位于绝对定位插槽中
    const isInAbsoluteSlot = (_getVNodeFactoryState => {
      const pathInfo = getCompPathParentInfo(compPath);
      // 找到父插槽
      const slots = (_getVNodeFactoryState = getVNodeFactoryState(this.renderer, pathInfo.parentCompPath)) === null || _getVNodeFactoryState === void 0 ? void 0 : _getVNodeFactoryState.getNormalSlots();
      const slotMeta = slots === null || slots === void 0 ? void 0 : slots.find(slot => slot.id === pathInfo.slotId);
      return (slotMeta === null || slotMeta === void 0 ? void 0 : slotMeta.position) === 'absolute';
    })();
    if (isInAbsoluteSlot) {
      // 绝对定位是否要检查溢出?
    } else if (((_this$activeCompMeta3 = this.activeCompMeta) === null || _this$activeCompMeta3 === void 0 ? void 0 : _this$activeCompMeta3.display) === 'inline') {
      var _this$dragSource;
      // 行内组件需要特殊对待
      const pathInfo = getCompPathParentInfo(compPath);
      const paragraphCompType = getBaseLayout(this.uc, 'paragraph').type;
      // 首先新插入的地方要有 w-paragraph 抱着
      const parent = this.getCompAtPath(pathInfo.parentCompPath);
      if (parent.type !== paragraphCompType) {
        const currentItem = this.getCompAtPath(compPath);
        let align = 'left';
        // 如果行 区域太小，就不要搞那个居中或者靠右边的逻辑
        if (o.slotWidth > 400) {
          if (o.offsetX > o.slotWidth * 0.8) align = 'right';else if (o.offsetX > o.slotWidth * 0.4) align = 'center';
        }
        await this.replaceCompWith(compPath, getBaseLayout(this.uc, 'paragraph', [currentItem], {
          props: {
            align
          }
        }));
        this.compPath = `${compPath}/default/0`;
      }
      // 然后如果他来自一个已经存在的 w-paragraph，拖动后原来那个为空行了，就删除！
      if ((_this$dragSource = this.dragSource) !== null && _this$dragSource !== void 0 && _this$dragSource.oldCompPath) {
        var _this$dragSource2, _prevParent$children;
        const tmp1 = getCompPathParentInfo((_this$dragSource2 = this.dragSource) === null || _this$dragSource2 === void 0 ? void 0 : _this$dragSource2.oldCompPath).parentCompPath;
        const prevParentPath = computeNewCompPath(tmp1, [{
          action: 'insertBefore',
          compPath
        }]);
        const prevParent = prevParentPath && this.getCompAtPath(prevParentPath);
        if (prevParentPath && prevParent && prevParent.type === paragraphCompType && !((_prevParent$children = prevParent.children) !== null && _prevParent$children !== void 0 && _prevParent$children.length)) {
          const newCurrentCompPath = computeNewCompPath(this.compPath, [{
            action: 'delete',
            compPath: prevParentPath
          }]);
          await this.deleteComp(prevParentPath);
          this.compPath = newCurrentCompPath;
        }
      }
    }
    (_this$dragSource3 = this.dragSource) === null || _this$dragSource3 === void 0 || (_this$dragSource3$onD = _this$dragSource3.onDrop) === null || _this$dragSource3$onD === void 0 || _this$dragSource3$onD.call(_this$dragSource3);
  }
  /** EditZone 当前高亮哪些组件，请使用 setHighlight 来操作！ */
  get highlightCompPaths() {
    return this.internalHighlightCompPaths;
  }
  /** 在 EditZone，高亮某个组件 */
  setHighlight(path, type) {
    if (!path) return;
    if (type) this.$set(this.internalHighlightCompPaths, path, type);else this.$delete(this.internalHighlightCompPaths, path);
  }
  $_watchDragging() {
    // 下面这些场景需要立即提交修改
    this.$watch('isDragging', v => !v && this.uc.notifyPageletsChange(0));
  }
  $_watchPageletsDeps() {
    // 自动更新依赖树。
    // TODO：需要考虑提供一个事件，而不是直接 watch 整个 pagelet
    this.$watch(() => this.pagelet, this.startCollectDeps, {
      deep: true,
      immediate: true
    });
    this.$once('hook:beforeDestroy', () => {
      this.startCollectDeps.cancel();
    });
  }
  /**
   * 获取最新的各种变量依赖信息。
   *
   * 如果当前 `this.deps` 是最新的，就会直接返回。否则，就等待收集完成再返回
   */
  getNewestDeps() {
    if (!this.depsIsUpdating) return Promise.resolve(this.deps);
    if (!this.depsCollectionProgress) this.startCollectDepsImmediately();
    return this.depsCollectionProgress.flush();
  }
  startCollectDepsImmediately() {
    var _this$startCollectDep, _this$depsCollectionP, _this$renderer4;
    (_this$startCollectDep = this.startCollectDeps) === null || _this$startCollectDep === void 0 || _this$startCollectDep.cancel();
    (_this$depsCollectionP = this.depsCollectionProgress) === null || _this$depsCollectionP === void 0 || _this$depsCollectionP.abort();
    this.depsIsUpdating = true;
    const ctx = {
      components: this.uc.components,
      flowAtoms: this.uc.flowAtoms,
      globalVariables: new Set(((_this$renderer4 = this.renderer) === null || _this$renderer4 === void 0 || (_this$renderer4 = _this$renderer4.ucFullDataSchema.fields) === null || _this$renderer4 === void 0 ? void 0 : _this$renderer4.map(x => x.id)) || [])
    };
    const pagelet = this.pagelet;
    function makeTrie() {
      return _makeTrie.apply(this, arguments);
    }
    function _makeTrie() {
      _makeTrie = _wrapAsyncGenerator(function* () {
        const trie = new Trie();
        const generator = collectDeps(ctx, {
          type: 'pagelet',
          value: pagelet
        });
        // eslint-disable-next-line no-restricted-syntax
        for (const dep of generator) {
          trie.add(dep.dataPath, dep);
          yield;
        }
        return trie;
      });
      return _makeTrie.apply(this, arguments);
    }
    const progress = resolveGenerator(makeTrie());
    this.depsCollectionProgress = progress;
    progress.promise.then(result => {
      if (progress === this.depsCollectionProgress) {
        this.deps = Object.seal(result); // 避免 Vue 糟心的依赖收集
        this.depsIsUpdating = false;
        this.depsCollectionProgress = null;
        this.$emit('deps-updated', this.deps);
      }
    }, () => {
      // failed to build tree
    });
  }
  /**
   * 获取一个变量相关的全部组件（注意，只是组件）的 CompPath
   *
   * 注意，由于 `deps` 是异步更新的，所以不一定能拿到最新的值。具体参见 deps 的注释
   */
  getRelatedCompPathsOfDataPath(dataPath) {
    var _this$deps;
    const pathParts = Array.isArray(dataPath) ? dataPath : splitPath(dataPath);
    const trie = (_this$deps = this.deps) === null || _this$deps === void 0 ? void 0 : _this$deps.getChildNode(pathParts);
    if (!trie) return {};
    const ans = {};
    trie.forEach(dep => {
      const {
        compPath
      } = dep;
      if (typeof compPath !== 'string') return;
      if (!ans[compPath]) ans[compPath] = [dep];else ans[compPath].push(dep);
    });
    return Object.freeze(ans);
  }
  // #endregion
  // ------------------------------------------------------
  // #region 组件库相关
  /**
   * 遍历组件库，生成“基础组件”面板里需要的内容。
   *
   * 返回的内容是已经根据 uc config 的配置排好序的
   */
  getMaterialBoxGroups(o = {}) {
    const {
      uc
    } = this;
    const groups = {};
    uc.config.categories.forEach(cat => {
      groups[cat.name] = {
        order: 1000,
        items: [],
        ...cat
      };
    });
    forEach(uc.components, (component, componentId) => {
      var _component$presets;
      if (o.filter && !o.filter(component)) return;
      const presets = (_component$presets = component.presets) !== null && _component$presets !== void 0 ? _component$presets : [{
        name: component.name || componentId,
        layout: {
          type: componentId
        }
      }];
      presets.forEach(preset => {
        var _preset$category, _ref, _preset$name, _preset$icon, _ref2, _preset$desc, _ref3, _preset$demo, _ref4, _preset$keywords;
        const groupName = (_preset$category = preset.category) !== null && _preset$category !== void 0 ? _preset$category : component.category;
        if (!groupName) return;
        if (!groups[groupName]) groups[groupName] = {
          name: groupName,
          order: 1000,
          items: []
        };
        const presetLayout = {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore  组件定义 layout 时可以偷懒不写 type
          type: componentId,
          ...cloneDeep(preset.layout)
        };
        // 默认值合并入 Layout
        // component.completeLayout(presetLayout);
        // 最后返回预设
        groups[groupName].items.push({
          name: (_ref = (_preset$name = preset.name) !== null && _preset$name !== void 0 ? _preset$name : component.name) !== null && _ref !== void 0 ? _ref : componentId,
          icon: (_preset$icon = preset.icon) !== null && _preset$icon !== void 0 ? _preset$icon : component.icon,
          desc: (_ref2 = (_preset$desc = preset.desc) !== null && _preset$desc !== void 0 ? _preset$desc : component.desc) !== null && _ref2 !== void 0 ? _ref2 : '',
          demo: (_ref3 = (_preset$demo = preset.demo) !== null && _preset$demo !== void 0 ? _preset$demo : component.demo) !== null && _ref3 !== void 0 ? _ref3 : '',
          keywords: (_ref4 = (_preset$keywords = preset.keywords) !== null && _preset$keywords !== void 0 ? _preset$keywords : component.keywords) !== null && _ref4 !== void 0 ? _ref4 : [],
          // 仅支持preset组件从组件面板拖入时触发onApply
          onApply: preset.onApply,
          display: component.display,
          layout: presetLayout
        });
      });
    });
    return values(groups).filter(x => {
      var _x$items;
      return x === null || x === void 0 || (_x$items = x.items) === null || _x$items === void 0 ? void 0 : _x$items.length;
    }) // eslint-disable-next-line no-nested-ternary
    .sort((a, b) => a.order - b.order || (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
  }
  changeMaterialBoxActiveGroup(key) {
    this.$refs.materialBox.activeKey = key;
  }
};
__decorate([lifeCycle('mounted')], UcDesigner.prototype, "saveZoomBetweenRendererAndDesigner", null);
__decorate([lifeCycle('created')], UcDesigner.prototype, "createZoomFitState", null);
__decorate([lifeCycle('beforeDestroy')], UcDesigner.prototype, "destroyZoomFitState", null);
__decorate([lifeCycle('created')], UcDesigner.prototype, "retrieveCompPathHistoryMaxNum", null);
__decorate([lifeCycle('created')], UcDesigner.prototype, "saveSkeletonStyle", null);
__decorate([Ref()], UcDesigner.prototype, "contextMenuRef", void 0);
__decorate([lifeCycle('created')], UcDesigner.prototype, "createMockState", null);
__decorate([lifeCycle('created')
// eslint-disable-next-line @typescript-eslint/naming-convention
], UcDesigner.prototype, "$_watchPageletId", null);
__decorate([lifeCycle('created')
// eslint-disable-next-line @typescript-eslint/naming-convention
], UcDesigner.prototype, "$_initCompPath", null);
__decorate([lifeCycle('beforeMount')
// eslint-disable-next-line @typescript-eslint/naming-convention
], UcDesigner.prototype, "$_initCompPathMounted", null);
__decorate([CalmComputedGetter()], UcDesigner.prototype, "activeCompType", null);
__decorate([lifeCycle('created')
// eslint-disable-next-line @typescript-eslint/naming-convention
], UcDesigner.prototype, "$_watchCompPath", null);
__decorate([lifeCycle('created')
// eslint-disable-next-line @typescript-eslint/naming-convention
], UcDesigner.prototype, "$_watchDragging", null);
__decorate([lifeCycle('created')
// eslint-disable-next-line @typescript-eslint/naming-convention
], UcDesigner.prototype, "$_watchPageletsDeps", null);
UcDesigner = __decorate([Component({
  name: 'UcDesigner'
})], UcDesigner);
export default UcDesigner;
//# sourceMappingURL=Designer.js.map
